"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGroceryList = exports.groceryListColors = void 0;
const client_1 = require("@apollo/client");
const react_1 = require("react");
const apolloComponents_1 = require("../generated/apolloComponents");
const common_1 = require("@saffron/common");
function getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
exports.groceryListColors = [
    "#D87446",
    "#E0D94A",
    "#0C65AE",
    "#70401A",
    "#F0A34D",
    "#34CCE1",
    "#C3D086",
    "#E84A3E",
    "#B9CADA",
    "#DE9397",
    "#4E8075",
    "#F4E08B",
    "#B5E9EA",
    "#0F839A",
    "#C49C3D",
    "#625A84",
    "#A6C3BF",
    "#EECC8B",
    "#908334",
    "#966593",
];
const recipeColorMap = {};
let colorIdx = 0;
exports.useGroceryList = ({ openGroups, fetchPolicy = "cache-and-network", } = {}) => {
    const { data, networkStatus, refetch, loading } = apolloComponents_1.useGroceryItemsQuery({
        notifyOnNetworkStatusChange: true,
        fetchPolicy,
        nextFetchPolicy: "cache-first",
    });
    const [collapsedCategoriesMap, setCollapsedCategories] = react_1.useState({});
    const [openBundlesMap, setOpenBundlesMap] = react_1.useState({});
    const onBundleToggle = react_1.useCallback(keyword => {
        setOpenBundlesMap(c => (Object.assign(Object.assign({}, c), { [keyword]: !c[keyword] })));
    }, []);
    const onCategoryClick = react_1.useCallback(id => {
        setCollapsedCategories(c => (Object.assign(Object.assign({}, c), { [id]: !c[id] })));
    }, []);
    const categoryMap = {};
    const keywordCount = {};
    const keywordCompleteCount = {};
    const recipeMap = {};
    const keywordToCatNameMap = {};
    for (const item of (data === null || data === void 0 ? void 0 : data.groceryItems.items) || []) {
        if (item.recipeId && !(item.recipeId in recipeMap)) {
            recipeMap[item.recipeId] = true;
        }
        if (item.recipeId && !(item.recipeId in recipeColorMap)) {
            if (colorIdx < exports.groceryListColors.length) {
                recipeColorMap[item.recipeId] = exports.groceryListColors[colorIdx];
                colorIdx += 1;
            }
            else {
                const color = getRandomColor();
                recipeColorMap[item.recipeId] = color;
                exports.groceryListColors.push(color);
                colorIdx += 1;
            }
        }
        if (item.keyword && !(item.keyword in keywordToCatNameMap)) {
            keywordToCatNameMap[item.keyword] = item.groceryCategoryName;
        }
        const catName = item.keyword
            ? keywordToCatNameMap[item.keyword]
            : item.groceryCategoryName;
        if (!(catName in categoryMap)) {
            categoryMap[catName] = {
                key: catName,
                data: [],
            };
        }
        categoryMap[catName].data.push(Object.assign(Object.assign({}, item), { groceryCategoryName: catName }));
        if (item.keyword && !item.recipeLinkId) {
            if (!(item.keyword in keywordCount)) {
                keywordCount[item.keyword] = 0;
                keywordCompleteCount[item.keyword] = 0;
            }
            keywordCount[item.keyword] += 1;
            if (item.complete) {
                keywordCompleteCount[item.keyword] += 1;
            }
        }
    }
    const catItems = common_1.sortBy(Object.values(categoryMap), cat => common_1.groceryCategoryNameToPositionMap[cat.key] || 100);
    const recyclerListItems = [
        { title: "input", open: true },
    ];
    for (const item of catItems) {
        const catOpen = !collapsedCategoriesMap[item.key];
        recyclerListItems.push({
            title: item.key,
            open: catOpen,
        });
        if (!catOpen) {
            continue;
        }
        const sortedData = common_1.sortBy(item.data, x => { var _a; return (_a = x.keyword) === null || _a === void 0 ? void 0 : _a.toLowerCase(); });
        let lastKeyword = null;
        for (const d of sortedData) {
            if (d.keyword &&
                d.keyword !== lastKeyword &&
                keywordCount[d.keyword] > 1) {
                const groupOpen = openBundlesMap[d.keyword];
                recyclerListItems.push({
                    groupKeyword: d.keyword,
                    complete: keywordCount[d.keyword] === keywordCompleteCount[d.keyword],
                    open: groupOpen,
                });
            }
            lastKeyword = d.keyword;
            const inGroup = !!(d.keyword && keywordCount[d.keyword] > 1);
            if (!inGroup || openBundlesMap[d.keyword] || openGroups) {
                recyclerListItems.push(Object.assign(Object.assign({}, d), { inGroup }));
            }
        }
    }
    return {
        onBundleToggle,
        onCategoryClick,
        recyclerListItems,
        recipes: ((data === null || data === void 0 ? void 0 : data.groceryItems.recipes) || []).filter(x => x.id in recipeMap),
        recipeColorMap,
        refreshing: networkStatus === client_1.NetworkStatus.refetch,
        refetch,
        loading,
    };
};
//# sourceMappingURL=useGroceryList.js.map